import { CalculationEditorController, ApiCrudObjectControllerBindings } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Editor for the given calculation.
 * @example
 * ```html
 * <salaxy-calc-editor model="'url'"></salaxy-calc-editor>
 * ```
 */
export class CalcEditor extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = (new class extends ApiCrudObjectControllerBindings {



    }());

    /** Uses the CalcReportController */
    public controller = CalculationEditorController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/calc/CalcEditor.html";

}
